import { render, staticRenderFns } from "./RenovarAbonoLfp.vue?vue&type=template&id=20b0794d"
import script from "./RenovarAbonoLfp.vue?vue&type=script&lang=js"
export * from "./RenovarAbonoLfp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports